<template>
  <div id="adminCrmStates">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ crm }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">{{ States }}</router-link>
      </li>
    </ol>
          <div class="container-fluid">
        <div class="card">          
        <div class="tab-content">
          <div class="card-body">
            <div class="row">
              <div class="col-3 text-left">
                <select2
                  id="select_AdminPagesView_IdLanguage"
                  ref="select_AdminPagesView_IdLanguage"
                  class="form-control nopadding"
                  style="width:75%"
                  :filterable="false"
                  service="languages"
                  v-model="
                    pageValueSelected.languagePageSetting.idLanguage
                  "
                  :default="defaultLanguageOptions"
                  :change="languageChange"                
                />
                <span>{{ language }}</span>
              </div>
              </div>
              </div>
              </div>
              </div>
              </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content">
          <div class="tab-pane active" id="tabTable" role="tabpanel">
            <div class="row">
              <div class="col-lg-6">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onNewCustomer"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
                <button
                  id="btnSave"
                  type="button"
                  class="btn btn-success"
                  @click="confirmSaveCustomer"
                  :disabled="disableButton"
                >
                  <i class="fa fa-floppy-o"></i>
                  <span>{{ save }}</span>
                </button>
                <button
                  id="btnDelete"
                  type="button"
                  class="btn btn-danger"
                  @click="confirmDeleteCustomer"
                  :disabled="disableButton"
                >
                  <i class="fa fa-trash"></i>
                  <span>{{ del }}</span>
                </button>
              </div>
            </div>
      
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="tableConfiguration"
                  :datas="tableData"
                  id="tableCustomer"
                  :onCheck="onTableCheckCustomer"
                  :onCheckAll="onTableCheckCustomer"
                  :onUncheck="onTableCheckCustomer"
                  :onUncheckAll="onTableCheckCustomer"
                  ref="tableCustomer"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
            <div class="card-header">{{newTitleStates}}</div>
            <div class="card-body">
              <div class="row">
               <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                <pageDetail
                  functions="adminCrmStates"
                  :configurations="detailConfiguration"
                  :jsonValue="detailData"
                ></pageDetail>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="confirmCancelNewCustomer"
                  ><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="confirmSaveNewCustomer"
                  ><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";

export default {
  name: "adminCrmStates",
  components: {
    BootstrapTable,
    Select2,
    PageDetail
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      language: dictionaryHelpers.getDictionary("Language"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      crm: dictionaryHelpers.getDictionary("CRM"),
      States: dictionaryHelpers.getDictionary("States"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      detailConfiguration: [],
      detailData: {},
      languages: 0,
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newCustomer: dictionaryHelpers.getDictionary("NewCustomer"),
      newTitleStates: dictionaryHelpers.getDictionary("newTitleStates"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: dictionaryHelpers.getDictionary("Save"),
      defaultLanguageOptions: [],
      pageValueSelected: {
      id: 0,
      languagePageSetting: { content: null }
      },
      tableConfiguration: [],
      tableCustomerResult: [],
      tableData: [],
      tableResult: [],
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      rowIdSelected: 0,
      rowsSelected: 0
    };
  },
  created() {
    var adminCrmStates = this;
    spinnerHelpers.show();
    
    this.languages = storageData.sIdLanguage();

    adminCrmStates.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

    adminConfigurationServices.getFunctionality(function(result) {
        adminCrmStates.tableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
        adminCrmStates.detailConfiguration = result.data.tabsConfigurations[0].pageConfigurations;

      adminCrmStates.loadTable();
    });
  },
  methods: {
    loadTable(ln) {
      var adminCrmStates = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }else{
        ln = this.languages; 
      }
      statesServices.getAll(ln,function(result) {
        adminCrmStates.tableData = result.data;
        spinnerHelpers.hide();
      });
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminCrmStates = this;
      this.languages = value;
      adminCrmStates.loadTable(value);
      spinnerHelpers.hide();
    },
    StatesFormatter(value, row, index, field) {
      var adminCrmStates = this;
      var html =
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html +=
        '<div class="col-1"><button class="btn btn-success" onclick="adminCrmStates.__vue__.executeOpenDetail(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button></div>';


      if (functionHelpers.isValued(this.tableResult)) {
        $.each(this.tableResult, function(i, result) {
          if (result.id == row.id) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminCrmStates.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div></div>";
      return html;
    },

    executeOpenDetail(id) {
      spinnerHelpers.show();
      var adminCrmStates = this;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;

      $.each(this.tableData, function(i, row) {
        if (adminCrmStates.rowIdSelected == row.id) {
          adminCrmStates.detailData = row;
        }
      });

      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

    onNewCustomer() {
      spinnerHelpers.show();

      this.detailData = {};
      this.titleDetail = this.newCustomer;
      this.rowIdSelected = 0;
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveCustomer() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveCustomer();
      }
    },

    executeSaveCustomer() {
      spinnerHelpers.show();
      var adminCrmStates = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableCustomer.getRowSelected(), function(i, row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        adminCrmStates.rowsSelected = adminCrmStates.rowsSelected + 1;
        //rowToSave.idlanguage=adminCrmStates.languages;

        statesServices.update(
          rowToSave,
          function() {
            adminCrmStates.checkAllIsSaved();
            adminCrmStates.tableResult.push({
              id: rowToSave.id,
              success: true
            });
            notificationHelpers.success(adminCrmStates.updateCompleted);
          },
          function(response) {
            adminCrmStates.checkAllIsSaved();
            adminCrmStates.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    confirmDeleteCustomer() {
      if (confirm(this.confirmDelete)) {
        this.executeDeleteCustomer();
      }
    },
    executeDeleteCustomer() {
      spinnerHelpers.show();
      var adminCrmStates = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableCustomer.getRowSelected(), function(i, row) {
        adminCrmStates.rowsSelected = adminCrmStates.rowsSelected + 1;

        statesServices.del(
          row.id,
          function() {
            adminCrmStates.checkAllIsSaved();
            notificationHelpers.success(adminCrmStates.deleteCompleted);
            
          },
          function(response) {
            adminCrmStates.checkAllIsSaved();
            adminCrmStates.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    onTableCheckCustomer() {
      var countRowSelected = this.$refs.tableCustomer.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelNewCustomer() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelCustomer();
      }
    },

    executeCancelCustomer() {
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
      $("#tabTable").addClass("active");
      $("#tabDetail").removeClass("active");
      spinnerHelpers.hide();
    },

    confirmSaveNewCustomer() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveNewCustomer();
      }
    },

    executeSaveNewCustomer() {
      spinnerHelpers.show();
      var adminCrmStates = this;
      this.detailData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (!functionHelpers.isValued(this.detailData.code)) {
        this.detailData.code = false;
      }

      if (!functionHelpers.isValued(this.detailData.description)) {
        this.detailData.description = false;
      }

      if (!functionHelpers.isValued(this.languages)) {
        this.detailData.idLanguage = storageData.sIdLanguage();
      } else {
        this.detailData.idLanguage = this.languages;
      }

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0
      ) {
        this.detailData.id = this.rowIdSelected;

        statesServices.update(this.detailData, function(result) {
          adminCrmStates.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmStates.updateCompleted
          });
          notificationHelpers.success(adminCrmStates.updateCompleted);
          adminCrmStates.loadTable(adminCrmStates.languages);
          $("#tabTable").addClass("active");
          $("#tabDetail").removeClass("active");
        });
      } else {
        
        statesServices.insert(this.detailData, function(result) {
          adminCrmStates.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmStates.insertCompleted
          });
          notificationHelpers.success(adminCrmStates.insertCompleted);
          adminCrmStates.loadTable(adminCrmStates.languages);
          $("#tabTable").addClass("active");
          $("#tabDetail").removeClass("active");
        });
      }
    },

    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable(this.languages);
      }
    }
  }
};
</script>
